import {
  Box,
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  MenuItem,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { ILegalRequirementTemplateFullObject } from '../Interfaces/ILegalRequirementTemplate';

import { Edit } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { DocumentOverview } from '../Document/DocumentOverview';
import { ICourtCourtRole } from '../Interfaces/IAemter';
import { IDocument } from '../Interfaces/IDocument';
import { ILegalPhaseTemplateFullObject } from '../Interfaces/ILegalPhaseTemplate';
import { ILegalRequirementTemplateDeadline } from '../Interfaces/ILegalRequirementTemplate_deadlines';
import { TextModuleSelector } from '../TextModule/TextModuleSelector';
import { CustomEditor } from '../core/CustomEditor';
import { LoadingSpinner } from '../core/LoadingSpinner';
import { getEmptyLegalRequirementTemplateFullObject } from '../core/generic_helper';
import { useGetLegalRequirementTemplateById } from '../hooks/reactQuerys/LegalRequirementQueries';
import { uploadFetch, useFetch } from '../hooks/useFetch';
import { State } from '../redux/mainReducer';
import { AddPrerequisiteDeadline } from './AddPrerequisiteDeadline';
import { LegalRequirementAddCourt } from './LegalRequirementAddCourt';
import { LegalRequirementDeadlineTable } from './LegalRequirementDeadlineTable';

interface IProps {
  currentRequirementTemplateid: number;
  setCurrentRequirementTemplateid: Function;
  legalPhaseTemplateArray?: ILegalPhaseTemplateFullObject[];
  setWasSaved: Function;
  title: string;
  setLegalRequirementTemplateWasSuccessfullySaved: Function;
}

export const LegalRequirementTemplateEdit: React.FC<IProps> = ({
  currentRequirementTemplateid,
  setCurrentRequirementTemplateid,
  legalPhaseTemplateArray,
  setWasSaved,
  setLegalRequirementTemplateWasSuccessfullySaved,
  title,
}) => {
  const [
    requirementArray,
    setrequirementArray,
    wasSuccessfullyRequirementArray,
  ] = useFetch<ILegalRequirementTemplateFullObject[]>(
    '/legalrequirementtemplate'
  );
  const {
    legalRequirementTemplate,
    isLegalRequirementTemplateFetching,
    refetchLegalRequirementTemplate,
  } = useGetLegalRequirementTemplateById(
    currentRequirementTemplateid > 0 ? currentRequirementTemplateid : 0
  );
  //
  const [editCurrentRequirement, setEditCurrentRequirement] =
    useState<ILegalRequirementTemplateFullObject>(
      getEmptyLegalRequirementTemplateFullObject()
    );
  const [currentDocumentArray, setCurrentDocumentArray] = useState<IDocument[]>(
    []
  );
  //
  useEffect(() => {
    if (legalRequirementTemplate !== undefined) {
      if (currentRequirementTemplateid >= 0) {
        setEditCurrentRequirement(legalRequirementTemplate);
        setCurrentDocumentArray(legalRequirementTemplate.DocumentArray);
      } else if (currentRequirementTemplateid < 0) {
        setEditCurrentRequirement(getEmptyLegalRequirementTemplateFullObject());
        setCurrentDocumentArray([]);
      }
    }
  }, [legalRequirementTemplate]);
  // Redux
  const legalRequirementStateArray = useSelector(
    (state: State) =>
      state.legalRequirementStateArray.storeLegalRequirementState
  );

  const [courtcourtRoleArray, , wasSuccessfullyLoadCourt] =
    useFetch<ICourtCourtRole[]>('/courtcourtrole');

  const [courtcourtroleDialogOpen, setCourtcourtroleDialogOpen] =
    useState(false);

  const [addPrerequisteDeadlineOpen, setAddPrerequisteDeadlineOpen] =
    useState(false);
  //
  const [isLoading, setIsLoading] = useState(false);

  const getCourtCourtRoleCurrentProcessingTime = useCallback(
    (idCourt: number, idCourtRole: number) => {
      if (courtcourtRoleArray === undefined) return null;
      const courtCourtRole = courtcourtRoleArray.find(
        x => x.idCourt === idCourt && x.idCourtRole === idCourtRole
      );
      return courtCourtRole?.currentProcessingTime
        ? courtCourtRole.currentProcessingTime
        : courtCourtRole?.initalProcessingTime;
    },
    [courtcourtRoleArray]
  );

  const wrappeHandleSaveRequirement = (
    localRequirement: ILegalRequirementTemplateFullObject
  ) => {
    if (editCurrentRequirement !== null && requirementArray !== undefined) {
      if (editCurrentRequirement?.idLegalRequirementTemplate < 0) {
        setrequirementArray([...requirementArray, localRequirement]);
        setLegalRequirementTemplateWasSuccessfullySaved(true);
      } else {
        setrequirementArray([
          ...requirementArray.map(x =>
            x.idLegalRequirementTemplate ===
            localRequirement.idLegalRequirementTemplate
              ? localRequirement
              : x
          ),
        ]);
      }
      setWasSaved(true);
      refetchLegalRequirementTemplate();
      setIsLoading(false);
      setCurrentRequirementTemplateid(null);
    }
  };

  const handleSaveRequirement = async () => {
    if (editCurrentRequirement !== null) {
      setIsLoading(true); // Ladezustand aktivieren
      const uploadObject = {
        ...editCurrentRequirement,
        DocumentArray: currentDocumentArray,
        canUploadFilesClient: Boolean(
          editCurrentRequirement.canUploadFilesClient
        ),
        canUploadFilesEmployees: Boolean(
          editCurrentRequirement.canUploadFilesEmployees
        ),
        hasError: Boolean(editCurrentRequirement.hasError),
        hasErrorFreeText: Boolean(editCurrentRequirement.hasErrorFreeText),
        isTemplate: Boolean(editCurrentRequirement.isTemplate),
        sendMail: Boolean(editCurrentRequirement.sendMail),
      } as ILegalRequirementTemplateFullObject;

      try {
        await uploadFetch(
          '/legalrequirementtemplate/fullObject',
          Number(editCurrentRequirement?.idLegalRequirementTemplate) < 0,
          uploadObject,
          wrappeHandleSaveRequirement,
          undefined, // setWasSuccessfullyUploaded
          undefined, // wasSaved
          undefined // setIsLoading
        );
      } catch (error) {
      } finally {
      }
    }
  };

  const handleChangePrerequisteDeadline = useCallback(
    (changedPrequiste: ILegalRequirementTemplateDeadline) => {
      const newArray = editCurrentRequirement.DeadlineArray
        ? editCurrentRequirement.DeadlineArray
        : [];

      if (changedPrequiste.idDeadline === -1) {
        changedPrequiste.idDeadline = Math.floor(Math.random() * 1000000);
        newArray.push(changedPrequiste);
      } else {
        const index = newArray.findIndex(
          x => x.idDeadline === changedPrequiste.idDeadline
        );
        if (index === -1) {
          newArray.push(changedPrequiste);
        } else {
          newArray[index] = changedPrequiste;
        }
      }
      setEditCurrentRequirement({
        ...editCurrentRequirement,
        DeadlineArray: newArray,
      });
    },
    [
      currentRequirementTemplateid,
      setCurrentRequirementTemplateid,
      legalPhaseTemplateArray,
    ]
  );

  const handleDeleteDeadline = useCallback(
    (index: number) => {
      const newArray = editCurrentRequirement.DeadlineArray
        ? editCurrentRequirement.DeadlineArray
        : [];
      newArray.splice(index, 1);
      setEditCurrentRequirement({
        ...editCurrentRequirement,
        DeadlineArray: newArray,
      });
    },
    [
      currentRequirementTemplateid,
      setCurrentRequirementTemplateid,
      legalPhaseTemplateArray,
    ]
  );

  if (
    !wasSuccessfullyLoadCourt ||
    !wasSuccessfullyLoadCourt ||
    !wasSuccessfullyRequirementArray
  ) {
    return <div>Fehler beim Laden der Daten</div>;
  } else if (
    courtcourtRoleArray === undefined ||
    requirementArray === undefined ||
    (legalRequirementTemplate === undefined &&
      currentRequirementTemplateid > 0 &&
      isLegalRequirementTemplateFetching)
  ) {
    return (
      <>
        <LoadingSpinner />
      </>
    );
  }
  return (
    <>
      <DialogTitle
        variant='h5'
        sx={{
          borderBottom: '1px solid #ccc', // Optional: Eine Trennlinie für visuelle Klarheit
        }}
      >
        {title}
      </DialogTitle>
      <DialogContent>
        <Box sx={{ m: 2 }}>
          <Grid container spacing={2}>
            <Grid item sm={2}>
              <TextField
                label='interne Maßnahme'
                value={
                  editCurrentRequirement.isInterneLegalRequirement === true
                    ? 'true'
                    : 'false'
                }
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  setEditCurrentRequirement({
                    ...editCurrentRequirement,
                    isInterneLegalRequirement: event.target.value === 'true',
                    sendMail:
                      event.target.value === 'true'
                        ? false
                        : editCurrentRequirement.sendMail,
                  })
                }
                size='small'
                fullWidth
                select
              >
                <MenuItem value='true'>Ja</MenuItem>
                <MenuItem value='false'>Nein</MenuItem>{' '}
              </TextField>
            </Grid>
            <Grid item sm={10}>
              <TextField
                label='Bedingung'
                value={editCurrentRequirement.LegalRequirementTemplate}
                error={editCurrentRequirement.LegalRequirementTemplate === ''}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  setEditCurrentRequirement({
                    ...editCurrentRequirement,
                    LegalRequirementTemplate: event.target.value,
                  })
                }
                size='small'
                fullWidth
              />
            </Grid>

            <Grid item sm={6}>
              <TextField
                label='Mitarbeiter kann Dateien hochladen'
                value={
                  editCurrentRequirement.canUploadFilesEmployees === true
                    ? 'true'
                    : 'false'
                }
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setEditCurrentRequirement({
                    ...editCurrentRequirement,
                    canUploadFilesEmployees: event.target.value === 'true',
                    DocumentArray:
                      event.target.value === 'false'
                        ? []
                        : editCurrentRequirement.DocumentArray,
                  });
                  setCurrentDocumentArray(
                    event.target.value === 'false' ? [] : currentDocumentArray
                  );
                }}
                size='small'
                fullWidth
                select
              >
                <MenuItem value='true'>Ja</MenuItem>
                <MenuItem value='false'>Nein</MenuItem>
              </TextField>
            </Grid>
            <Grid item sm={6}>
              <TextField
                label='Mandant kann Dateien hochladen'
                value={
                  editCurrentRequirement.canUploadFilesClient === true
                    ? 'true'
                    : 'false'
                }
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  setEditCurrentRequirement({
                    ...editCurrentRequirement,
                    canUploadFilesClient: event.target.value === 'true',
                  })
                }
                size='small'
                fullWidth
                select
              >
                <MenuItem value='true'>Ja</MenuItem>
                <MenuItem value='false'>Nein</MenuItem>
              </TextField>
            </Grid>

            <Grid item sm={5}>
              <TextField
                label='Startstatus'
                value={editCurrentRequirement.idLegalRequirementState}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  setEditCurrentRequirement({
                    ...editCurrentRequirement,
                    idLegalRequirementState: Number(event.target.value),
                  })
                }
                size='small'
                fullWidth
                select
              >
                {legalRequirementStateArray.map(x => (
                  <MenuItem
                    key={`idLegalRequirementState-${x.idLegalRequirementState}`}
                    value={x.idLegalRequirementState}
                  >
                    {x.LegalRequirementState}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid item sm={3}>
              <TextField
                label='Vorlage im MA-Katalog'
                disabled={editCurrentRequirement.idLegalPhaseTemplate === null}
                value={
                  editCurrentRequirement.isTemplate === true ? 'true' : 'false'
                }
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  setEditCurrentRequirement({
                    ...editCurrentRequirement,
                    isTemplate: event.target.value === 'true',
                  })
                }
                size='small'
                fullWidth
                select
              >
                <MenuItem value='true'>Ja</MenuItem>
                <MenuItem value='false'>Nein</MenuItem>
              </TextField>
            </Grid>

            <Grid item sm={4}>
              <TextField
                label='Vorgänger (Bedingung)'
                value={
                  editCurrentRequirement.Predecessor_idLegalRequirementTemplate ===
                  undefined
                    ? ''
                    : editCurrentRequirement.Predecessor_idLegalRequirementTemplate
                }
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  setEditCurrentRequirement({
                    ...editCurrentRequirement,
                    Predecessor_idLegalRequirementTemplate: Number(
                      event.target.value
                    ),
                  })
                }
                size='small'
                fullWidth
                select
              >
                {requirementArray.map(x => (
                  <MenuItem
                    key={`predecessor-idLegalRequirementTemplate-${x.idLegalRequirementTemplate}`}
                    value={x.idLegalRequirementTemplate}
                  >
                    {x.LegalRequirementTemplate}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            {editCurrentRequirement.canUploadFilesEmployees === true && (
              <Grid mt={6} item sm={12}>
                <DocumentOverview
                  documentArray={currentDocumentArray}
                  setDocumentArray={setCurrentDocumentArray}
                  allowUpload={true}
                  allowRemove={true}
                  title={'Standarddokumente'}
                  isStandarddocument={true}
                  isTemplate={true}
                />
              </Grid>
            )}

            <Grid item sm={12}>
              <Box
                component='fieldset'
                sx={{
                  borderColor: '#ccc',
                  border: 1,
                  borderRadius: 4,
                  padding: 2,
                  marginTop: 4,
                  position: 'relative',
                }}
              >
                <Typography
                  component='legend'
                  sx={{ fontSize: '0.875rem', padding: '0 8px' }}
                >
                  Fristen und Gerichte
                </Typography>
                <Grid container spacing={2} justifyContent='center'>
                  {editCurrentRequirement.idCourt === null &&
                    editCurrentRequirement.idCourtRole === null && (
                      <>
                        <Grid
                          item
                          xs={12}
                          display={'flex'}
                          alignItems={'center'}
                          justifyContent={'space-between'}
                        >
                          <Tooltip title='Die geschätzte Bearbeitungszeit ist die geschätzte Zeit für den Abschluss dieser Maßnahme unter normalen Umständen. Sollten Sie die geschätzte Bearbeitungszeit ändern, wird nach dem Speichern eine neue Kalkulation der berechneten Bearbeitungszeit auf Grundlage der historischen Daten und der geschätzen Bearbeitungszeit durchgeführt. Sie sehen das neue Ergebnis, wenn Sie diese Maßnahme erneut laden'>
                            <TextField
                              label='Geschätzte Bearbeitungszeit'
                              type='number'
                              value={
                                editCurrentRequirement.initialProcessingTime
                                  ? editCurrentRequirement.initialProcessingTime
                                  : ''
                              }
                              onChange={(
                                event: React.ChangeEvent<HTMLInputElement>
                              ) =>
                                setEditCurrentRequirement({
                                  ...editCurrentRequirement,
                                  initialProcessingTime: Number(
                                    event.target.value
                                  ),
                                })
                              }
                              size='small'
                              sx={{ width: '50%' }}
                            />
                          </Tooltip>
                          <Tooltip title='Die berechnete Bearbeitungszeit ist die durchschnittliche Zeit, die für die Bearbeitung dieser Maßnahme benötigt wird. Die Berechnung basiert auf den Daten bereits abgeschlossener Maßnahmen. Sollten noch keine Daten vorliegen, wird die geschätzte Bearbeitungszeit angezeigt.'>
                            <Typography
                              variant='body1'
                              color='text.secondary'
                              sx={{
                                width: '100%',
                                display: 'flex',
                                justifyContent: 'flex-end',
                                textAlign: 'right',
                              }}
                            >
                              Berechnete Bearbeitungszeit:{' '}
                              {editCurrentRequirement.currentProcessingTime !==
                              null
                                ? `${editCurrentRequirement.currentProcessingTime} Tage`
                                : editCurrentRequirement.initialProcessingTime !==
                                    null
                                  ? `${editCurrentRequirement.initialProcessingTime} Tage`
                                  : 'noch nicht festgelegt'}
                            </Typography>
                          </Tooltip>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          display='flex'
                          alignItems='center'
                          justifyContent='space-between'
                        ></Grid>
                        <Tooltip title='Alternativ können Sie auch ein zuständiges Amt für diese Maßnahme festlegen. Die Bearbeitungszeit wird dann automatisch basierend auf den Daten des zuständigen Amts kaluliert.'>
                          <Button
                            variant='contained'
                            color='primary'
                            sx={{ mt: 1 }}
                            onClick={() => {
                              setCourtcourtroleDialogOpen(true);
                            }}
                          >
                            Zuständiges Amt festlegen
                          </Button>
                        </Tooltip>
                      </>
                    )}
                  <Grid item xs={12}>
                    <Box>
                      {editCurrentRequirement.idCourt !== null &&
                        editCurrentRequirement.idCourtRole !== null && (
                          <>
                            <Grid
                              item
                              xs={12}
                              display={'flex'}
                              alignItems={'center'}
                              justifyContent={'space-between'}
                            >
                              <Tooltip title='Das Amt, welches für die Bearbeitung dieser Maßnahme zuständig ist.'>
                                <Typography variant='body1'>
                                  Amt: {editCurrentRequirement.CourtRole}{' '}
                                  {editCurrentRequirement.Court}
                                </Typography>
                              </Tooltip>
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              display={'flex'}
                              alignItems={'center'}
                              justifyContent={'space-between'}
                            >
                              <Tooltip title='Die berechnete Bearbeitungszeit ist die durchschnittliche Zeit, die für die Bearbeitung durch das zuständige Amt benötigt wird. Die Berechnung basiert auf den Daten bereits abgeschlossener Maßnahmen. Sollten noch keine Daten vorliegen, wird die geschätzte Bearbeitungszeit des Gerichts angezeigt.'>
                                <Typography variant='subtitle1'>
                                  Berechnete Bearbeitungszeit:{' '}
                                  {getCourtCourtRoleCurrentProcessingTime(
                                    editCurrentRequirement.idCourt,
                                    editCurrentRequirement.idCourtRole
                                  )}{' '}
                                  Tage
                                </Typography>
                              </Tooltip>
                            </Grid>
                            <Box display='flex' gap={2}>
                              <Tooltip title='Ändern Sie die Zuweisung zu einem anderen Amt'>
                                <Button
                                  variant='contained'
                                  color='primary'
                                  sx={{ mt: 1 }}
                                  onClick={() => {
                                    setCourtcourtroleDialogOpen(true);
                                  }}
                                >
                                  Zuweisung ändern
                                </Button>
                              </Tooltip>
                              <Tooltip title='Alternativ können Sie auch die Zuweisung zu einem Amt löschen. Die Bearbeitungszeit wird dann basierend auf historischen Daten der Maßnahme berechnet.'>
                                <Button
                                  variant='contained'
                                  color='warning'
                                  sx={{ mt: 1 }}
                                  onClick={() => {
                                    setEditCurrentRequirement({
                                      ...editCurrentRequirement,
                                      idCourt: null,
                                      idCourtRole: null,
                                      Court: null,
                                      CourtRole: null,
                                    });
                                  }}
                                >
                                  Zuweisung löschen
                                </Button>
                              </Tooltip>
                            </Box>
                          </>
                        )}

                      <Divider>
                        <Typography variant='subtitle1'>
                          Startbedingungen
                        </Typography>
                      </Divider>
                      <Grid
                        item
                        xs={12}
                        display={'flex'}
                        justifyContent={'right'}
                      >
                        <Tooltip title='Bearbeiten Sie die Startbedingungen'>
                          <IconButton
                            onClick={() => setAddPrerequisteDeadlineOpen(true)}
                          >
                            <Edit />
                          </IconButton>
                        </Tooltip>
                      </Grid>
                      <LegalRequirementDeadlineTable
                        deadlineArray={editCurrentRequirement?.DeadlineArray}
                        setDeadline={handleChangePrerequisteDeadline}
                        deleteDeadline={handleDeleteDeadline}
                      ></LegalRequirementDeadlineTable>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
            <Grid item sm={12}>
              <TextModuleSelector
                key={`type-legalrequirementedit`}
                floatRight
                idTextModuleCategory={4}
                txt={editCurrentRequirement?.InfoText || ''}
                setTxt={(txt: string) =>
                  setEditCurrentRequirement({
                    ...editCurrentRequirement,
                    InfoText: txt,
                  })
                }
              />
              <TextField
                label='Infotext'
                value={
                  editCurrentRequirement?.InfoText === null
                    ? ''
                    : editCurrentRequirement?.InfoText
                }
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  setEditCurrentRequirement({
                    ...editCurrentRequirement,
                    InfoText:
                      event.target.value === '' ? null : event.target.value,
                  })
                }
                size='small'
                fullWidth
                multiline
                rows={3}
              />
            </Grid>

            <Grid item sm={4}>
              <TextField
                label='Auto. E-Mail versenden (wenn erfüllt)'
                value={
                  editCurrentRequirement.sendMail === true ? 'true' : 'false'
                }
                disabled={
                  editCurrentRequirement.isInterneLegalRequirement === true
                }
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  setEditCurrentRequirement({
                    ...editCurrentRequirement,
                    sendMail: event.target.value === 'true',
                  })
                }
                size='small'
                fullWidth
                select
              >
                <MenuItem value='true'>Ja</MenuItem>
                <MenuItem value='false'>Nein</MenuItem>
              </TextField>
            </Grid>

            <Grid item sm={8}>
              <TextField
                label='E-Mail Betreff'
                value={editCurrentRequirement.EmailSubject}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  setEditCurrentRequirement({
                    ...editCurrentRequirement,
                    EmailSubject: event.target.value,
                  })
                }
                size='small'
                fullWidth
              />
            </Grid>

            <CustomEditor
              txt={
                editCurrentRequirement.EmailBody === null
                  ? ''
                  : editCurrentRequirement.EmailBody
              }
              setTxt={(txt: string) =>
                setEditCurrentRequirement({
                  ...editCurrentRequirement,
                  EmailBody: txt === '' ? null : txt,
                })
              }
              idTextModuleCategory={3}
              dictonaryIdsArray={[1, 2, 3]}
            />

            <Grid item sm={6}>
              <TextField
                label='Fehler möglich'
                value={
                  editCurrentRequirement.hasError === true ? 'true' : 'false'
                }
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  setEditCurrentRequirement({
                    ...editCurrentRequirement,
                    hasError: event.target.value === 'true',
                  })
                }
                size='small'
                fullWidth
                select
              >
                <MenuItem value='true'>Ja</MenuItem>
                <MenuItem value='false'>Nein</MenuItem>
              </TextField>
            </Grid>
            <Grid item sm={6}>
              <TextField
                label='Freitext bei Fehler erlauben'
                value={
                  editCurrentRequirement.hasErrorFreeText === true
                    ? 'true'
                    : 'false'
                }
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  setEditCurrentRequirement({
                    ...editCurrentRequirement,
                    hasErrorFreeText: event.target.value === 'true',
                  })
                }
                size='small'
                fullWidth
                select
              >
                <MenuItem value='true'>Ja</MenuItem>
                <MenuItem value='false'>Nein</MenuItem>
              </TextField>
            </Grid>

            <Grid item sm={12}>
              <TextField
                label='Fehlermeldung'
                value={editCurrentRequirement.TextOfError}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  setEditCurrentRequirement({
                    ...editCurrentRequirement,
                    TextOfError: event.target.value,
                  })
                }
                size='small'
                fullWidth
                multiline
                rows={3}
              />
            </Grid>
          </Grid>
          <LegalRequirementAddCourt
            legalRequirement={editCurrentRequirement}
            courtCourtRoleArray={courtcourtRoleArray}
            open={courtcourtroleDialogOpen}
            onSave={(
              newLegalRequirement: ILegalRequirementTemplateFullObject
            ) => {
              setEditCurrentRequirement(newLegalRequirement);
              setCourtcourtroleDialogOpen(false);
            }}
            onClose={() => setCourtcourtroleDialogOpen(false)}
          />
          <AddPrerequisiteDeadline
            open={addPrerequisteDeadlineOpen}
            currentLegalRequirementTemplate={editCurrentRequirement}
            legalRequirementTemplateArray={requirementArray}
            setDeadline={handleChangePrerequisteDeadline}
            onClose={() => setAddPrerequisteDeadlineOpen(false)}
            legalPhaseTemplateArray={legalPhaseTemplateArray}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          variant='outlined'
          onClick={() => setCurrentRequirementTemplateid(null)}
        >
          Schließen
        </Button>
        <Button
          variant='contained'
          disabled={
            isLoading || editCurrentRequirement?.LegalRequirementTemplate === ''
          }
          onClick={handleSaveRequirement}
          color='success'
        >
          {isLoading ? (
            <Box display='flex' alignItems='center' gap={1}>
              <span>Speichern</span>
              <CircularProgress size={20} />
            </Box>
          ) : (
            'Speichern'
          )}
        </Button>
      </DialogActions>
    </>
  );
};
